import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { i18n, loadLocaleMessages, refreshServerTranslations } from './locales'
import { api } from './lib/api'
import { initSentry } from './lib/sentry'
import './assets/main.css'
import './marketing/marketing.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

// Initialise Sentry as soon as the router is wired so it can capture
// route-change errors. Dynamic import means no-DSN builds skip the SDK
// download entirely.
void initSentry(app, router)

// Fire-and-forget — fetch server-side translation overrides in the background.
// Missing endpoint doesn't break the app (the helper swallows errors).
void refreshServerTranslations(async () => {
  const { data } = await api.get<Record<string, Record<string, string>>>('/translations')
  return data
})

// Initial locale may be a lazily-loaded bundle (e.g. saved 'pl'); load it before first paint.
void loadLocaleMessages(i18n.global.locale.value).finally(() => app.mount('#app'))
